import {
  getSessionStorageValue,
  removeSessionStorageValue,
  setSessionStorageValue
} from 'dpl/shared/utils/sessionStorage';

const STORAGE_KEY = 'post_auth_scroll_target';

export interface PostAuthScrollTarget {
  path: string;
  followableType: string;
  followableId: number;
  scrollY: number;
}

export function getFollowableKey(type: string, id: number | string) {
  return `${type}-${id}`;
}

export function getFollowableSelector(type: string, id: number | string) {
  return `[data-followable="${getFollowableKey(type, id)}"]`;
}

export function savePostAuthScrollTarget(
  target: Omit<PostAuthScrollTarget, 'path' | 'scrollY'>
) {
  setSessionStorageValue(STORAGE_KEY, {
    ...target,
    path: window.location.pathname,
    scrollY: window.scrollY
  });
}

export function takePostAuthScrollTarget(): PostAuthScrollTarget | null {
  const target = getSessionStorageValue<PostAuthScrollTarget>(STORAGE_KEY);
  removeSessionStorageValue(STORAGE_KEY);
  return target;
}

export function clearPostAuthScrollTarget() {
  removeSessionStorageValue(STORAGE_KEY);
}
